/*eslint-disable */
define(['underscore', 'common/log'], function(_, log) {
    /**
     * Format one of multiple simple templates, selecting the template based on a number.
     *
     * The template is a comma separated list of choices.
     * Each choice has two parts colon separated parts; , a range (to match the number against) and a template
     *     1-2:# things
     *
     * The first choice with a range that matches the passed number is used.
     *
     * The range part consists of two '-' separated numbers. One or both number may be present
     *     3           exactly 3
     *     2-5        2 to 5 inclusive
     *     -4       less than or equal to 4
     *     7-       7 or greater
     *
     * The template for a choice is a string, with an optional #.
     * The # is a placeholder where the number may be substituted.
     *
     * A slightly crazy example of a template string.
     *     "-2:# widget,3:# widgetz,4-5:# widgetum,7-:# widgets"
     *
     * See the choice-formatter-test module for examples.
     *
     * @param template    string    the templates, and conditions for matching
     * @param number    Number  the number to use for matching with a template.
     */
    function format(template, number) {
        if (typeof number !== 'number') {
            log.client(log.ERROR, 'Expected a number, not "' + number + '", to format choice "' + template + '"');
            return '';
        }

        var choices = _.map(template.split(','), function(value, index) {
            var parts = value.split(':');
            if (parts.length != 2) {
                log.client(log.WARN, 'Skipping invalid choice part', value);
            }

            var range = parts[0];
            var template = parts[1];
            var rangeParts = range.split('-')
            var lower;
            var upper;

            switch (rangeParts.length) {
            case 1:
                if (rangeParts[0]) {
                    lower = parseInt(rangeParts[0]);
                    upper = lower;
                }
                break;
            case 2:
                if (rangeParts[0]) {
                    lower = parseInt(rangeParts[0]);
                }
                if (rangeParts[1]) {
                    upper = parseInt(rangeParts[1]);
                }
                break;
            default:
                log.client(log.WARN, 'Invalid range', range)
                break;
            }

            return {
                lower: lower,
                upper: upper,
                template: template
            };
        });

        var matchingChoice = _.find(choices, function(choice) {
            var lower = choice.lower !== undefined ? choice.lower : -Infinity;
            var upper = choice.upper !== undefined ? choice.upper : Infinity;

            if (number < choice.lower) {
                return false;
            }

            if (number > choice.upper) {
                return false;
            }

            return true;
        });

        if (matchingChoice) {
            return matchingChoice.template.replace('#', number);
        } else {
            log.client(log.WARN, 'No matching choice for ' + number + ' in "' + template + '"');
            return '';
        }
    }

    return {
        format: format,
    };
});
